(function(){

  'use strict'

    angular.module('clooper',[])
        .config(preRuntimeConfig)
        .run(runtimeConfig)
        .directive('wpAjaxForm', wpAjaxFormDirective)

    preRuntimeConfig.$inject = ['$httpProvider']
    /* ngInject */
    function preRuntimeConfig($httpProvider) {
        //Enable cross domain calls
        $httpProvider.defaults.useXDomain = true
        //Remove the header used to identify ajax call  that would prevent CORS from working
        delete $httpProvider.defaults.headers.common['X-Requested-With']
    }

    runtimeConfig.$inject = ['$window']
    /* ngInject */
    function runtimeConfig($window) {

        $(function() {

            if ($(document).innerWidth() >= 768) {
                // Intercept sharing links to open in small popup window
                $('body .share-links').on('click', 'a', function(ev){
                  ev.preventDefault()
                  if ( /facebook|twitter/.test(ev.currentTarget.href) ) {
                    const c = 575,
                        d = 520,
                        e = ($(window).width() - c) / 2,
                        f = ($(window).height() - d) / 2,
                        g = `status=1,width=${c},height=${d},top=${f},left=${e}`
                    window.open(ev.currentTarget.href, 'Share Clooper Blog with your friends and family', g)
                  } 
                  else if (/whatsapp/.test(ev.currentTarget.href)) {
                    const article = $(this).data('text'),
                        weburl = $(this).data('link'),
                        whats_app_message = encodeURIComponent(`${article} - ${weburl}`),
                        whatsapp_url = `whatsapp://send?text=${whats_app_message}`
                    window.location.href = whatsapp_url
                  }
                  else window.open(ev.currentTarget.href)
                })
            } else {
                // let other links open normally
                // however, intercept whatsapp share link to encode text
                $('body .share-links').on('click', 'a[href|="whatsapp"]', function(e) {
                    e.preventDefault() 
                    const article = $(this).data('text'),
                        weburl = $(this).data('link'),
                        whats_app_message = encodeURIComponent(`${article} - ${weburl}`),
                        whatsapp_url = `whatsapp://send?text=${whats_app_message}`
                    window.location.href = whatsapp_url
                })
            }

            $('[data-toggle="tooltip"]').tooltip({ offset: `0, -${$('.navbar').outerHeight()}` })

            
            $(window).on('scroll', () => {
                var backToTop = document.getElementById('back-to-top')
                if (document.body.scrollTop > 28 || document.documentElement.scrollTop > 28) {
                    backToTop.style.display = 'inline-table';
                } else {
                    backToTop.style.display = 'none';
                }
            })

            $('body')
                .on('hidden.bs.modal', function(event){
                    $(event.target).remove()
                    $('body').off('hidden.bs.modal', this)
                })    
                .on('shown.bs.modal', function(event){
                    $(event.target).parent().addClass('in-active')
                })
                .on('hide.bs.modal', function(event){
                    $(event.target).parent().removeClass('in-active').addClass('out-active')
                })
                .on('click', '#back-to-top', function(){
                    return $('body,html').animate({ scrollTop: 0}, 800)
                })
                // show navbar dropdown menu on hover 
                .on('hover', '.dropdown', function(){
                    const dropdownMenu = $(this).children('.dropdown-menu');
                    if (dropdownMenu.is(':visible')) {
                        dropdownMenu.parent().toggleClass('open');
                    }
                })
                 // show responsive nav menu when hamburger icon is clicked
                .on('click', '.hamburger', function(event){
                    event.stopImmediatePropagation()
                    event.preventDefault()
                    $(event.currentTarget).toggleClass('is-active')
                    $('body').toggleClass('main-nav-open')
                    $('.main-nav').css('top', window.pageYOffset - 10)
                    if ($(event.currentTarget).hasClass('is-active')) {
                        const count = $('.main-nav .nav-menu li').length
                        $('.main-nav .nav-menu li').each(function(i, elem) {
                            elem.classList.add('animate__animated', 'animate__fadeInTopLeft')
                            elem.style.setProperty('--animate-duration', `${(0.5 * i + 1) / 2}s`)
                        })
                    }
                })
                // show loading state on form button when form is submitted
                /* .on('submit', 'form', function(event){
                    const $btn = $(event.target).find('button:not(.close)'), text = $btn.html()
                    $btn.data('text', text).html(' ••• ').attr('disabled', 'disabled')
                }) */
                // restore the initial form button label when form is reset
                .on('reset', 'form', function(event){
                    const $btn = $(event.target).find('button:disabled')
                    $btn.html($btn.data('text')).removeAttr('disabled').removeData('text')
                })
        })

    }

    function wpAjaxFormDirective() {
        return {
            restrict:'EA',
            controller: WPAjaxFormController,
            controllerAs:'vm',
            scope:true,
            bindToController:{
              action: '@postAction',
              nonce: '@postNonce',
              captcha_action: '@captchaAction',
              post_type: '@postType',
              post_id: '@postId',
              quiet_success: '@quietSuccess'
            }
        }
    }

    WPAjaxFormController.$inject = ['$scope', '$element','$http', '$window', '$timeout']
    /* ngInject */
    function WPAjaxFormController($scope, $element, $http, $window, $timeout) {

        var vm = this

        vm.data = {}

        $element.on('submit', submit)

        function submit () {
          $($element).find('.response-error, .response-success').remove()
          grecaptcha.ready(function() {
              grecaptcha.execute($window.clooper.RECAPTCHA_SITE_KEY || $window.RECAPTCHA_SITE_KEY, { action: vm.captcha_action }).then(function(token) {
                 vm.data.recaptcha_token = token
                 vm.data.post_type = vm.post_type
                 if (vm.post_id !== undefined) vm.data.post_id = vm.post_id
                 return $http({
                     method:'POST',
                     url: $window.clooper.ajaxURL,
                     data: vm.data,
                     params: {
                       nonce: $window.clooper[vm.nonce],
                       action: vm.action
                     }
                 }).then(function(resp){
                    $($element).trigger('success', resp.data)
                    if (!vm.quiet_success) {
                        $($element).trigger('reset')
                        $($element).find('.response-placeholder').append('<span class="response-success animated animate__fadeIn">'+ resp.data.success +'</span>')
                        $timeout(function(){
                            vm.data = {}
                            $($element).find('.response-success').remove()
                        }, 5000)
                   }
                 }, function (error) {
                   $($element).trigger('error', error.data)
                   $($element).find('.response-placeholder').append('<span class="response-error animated animate__fadeIn">'+ error.data.error +'</span>')
                   $timeout(function(){
                     $($element).find('.response-error').remove()
                   }, 5000)
                 })
              })
          })
        }
    }

})()
